import React from 'react'
import {
  AlignSelf,
  Box,
  Display,
  Heading2,
  JustifyContent,
  Space,
} from '@gousto-internal/citrus-react'
import { BenefitItem, LandingPageButton, TwoColumnLayout } from '../../../../components'
import type { HowGoustoFoodBoxesWorkTypes } from '../../../../types'
import { FoodBoxPageSections, TargetUri, TrackingActions } from '../../../../types/tracking'
import goustovalue from '../../../../sections/assets/goustovalue.jpg'
import { BENEFITS } from './config'

export function BenefitsOfGoustoSection({ startOnboarding }: HowGoustoFoodBoxesWorkTypes) {
  return (
    <TwoColumnLayout image={{ src: goustovalue, alt: BENEFITS.altText }}>
      <Box alignSelf={AlignSelf.Start}>
        <Heading2>{BENEFITS.heading}</Heading2>
        <Space size={5} />

        {BENEFITS.benefits.map((benefit) => (
          <BenefitItem key={benefit.title} title={benefit.title}>
            {benefit.description}
          </BenefitItem>
        ))}

        <Space size={6} />
        <Box
          display={Display.Flex}
          justifyContent={[JustifyContent.Center, JustifyContent.FlexStart]}
        >
          <LandingPageButton
            startOnboarding={startOnboarding}
            sectionName={FoodBoxPageSections.BENEFITS_SECTION}
            target={TargetUri.SUSTAINABILITY_IMPACT_REPORT}
            action={TrackingActions.SUSTAINABILITY_NAVIGATION_CLICKED}
          >
            {BENEFITS.ctaText}
          </LandingPageButton>
        </Box>
      </Box>
    </TwoColumnLayout>
  )
}
